const SmoothScroll = {

	headerHeightScrollingDown: 80,
	headerHeightScrollingUp: 142,
	globalOffset: 0,

	init: () => {
		const links = document.querySelectorAll('a');
		links.forEach((link) => {
			link.addEventListener('click', (ev) => {
				if(link.hasAttribute('[data-fancybox]')){
					return;
				}
				const href = link.getAttribute('href');
				const currentUrl = window.location.href;

				if(href === currentUrl || href === '#'){
					ev.preventDefault();
					SmoothScroll.scroll(0);
				}
				if(href.indexOf('#') === -1){
					return;
				}
				const hrefParts = href.split('#');

				if(currentUrl === hrefParts[0] || hrefParts[0] === ''){
					ev.preventDefault();
				}
				if(hrefParts[1] === ''){
					return;
				}
				const targetElement = document.querySelector('#'+hrefParts[1]);
				if(!targetElement){
					return;
				}
				let scrollModify = 0;
				if(link.dataset.scrollModify){
					scrollModify = parseInt(link.dataset.scrollModify);
				}
				SmoothScroll.scrollToElement(targetElement, scrollModify);

			})
		})

		SmoothScroll.initScrollBelowSection();
	},

	initScrollBelowSection: () => {
		const buttons = document.querySelectorAll(`[data-scroll-below]`);
		buttons.forEach((button) => {
		    button.addEventListener('click', (ev) => {
				ev.preventDefault();
				const targetSelector = button.getAttribute('data-scroll-below');
				let target = button.closest(targetSelector);
				if(!target){
					target = document.querySelector(targetSelector);
				}
				if(!target) return;

				const rect = target.getBoundingClientRect();
				SmoothScroll.scroll(rect.x + rect.height);
			})
		})
	},

	scrollToElement: (element, offset = 0) => {
		// console.log(element.offsetTop);
		// console.log(element.getBoundingClientRect().top + document.documentElement.scrollTop);
		SmoothScroll.scroll(element.getBoundingClientRect().top + document.documentElement.scrollTop, offset);
	},

	scroll: (top, offset = 0) => {
		let headerHeight = SmoothScroll.headerHeightScrollingDown;
		if(window.scrollY > top){
			headerHeight = SmoothScroll.headerHeightScrollingUp;
		}
		let scrollTo = top + offset - headerHeight + SmoothScroll.globalOffset;
		if(scrollTo < 0) scrollTo = 0;

		//FIXME too fast on safari
		window.scroll({
			top: scrollTo,
			left: 0,
			behavior: 'smooth'
		});
	}
}


export default SmoothScroll;
